import React, { useState } from "react";
import { productionAnomalies } from "../services/productionAnomaliesData";

const ManageProductionAnomalies = () => {
    const [anomalies, setAnomalies] = useState(productionAnomalies);
    const [form, setForm] = useState({
        description: "",
        step: "",
        operator: "",
        status: "Signalée", // Statut par défaut
    });
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const handleAddAnomaly = (e) => {
        e.preventDefault();

        // Validation des champs
        if (!form.description || !form.step || !form.operator) {
            setError("Tous les champs sont obligatoires.");
            setSuccessMessage("");
            return;
        }

        const newAnomaly = {
            id: anomalies.length + 1,
            ...form,
            date: new Date().toISOString().split("T")[0], // Date du jour
        };

        setAnomalies([...anomalies, newAnomaly]);
        setForm({
            description: "",
            step: "",
            operator: "",
            status: "Signalée",
        });
        setError("");
        setSuccessMessage("Anomalie ajoutée avec succès !");
    };

    const handleResolveAnomaly = (id) => {
        const updatedAnomalies = anomalies.map((anomaly) =>
            anomaly.id === id ? { ...anomaly, status: "Résolue" } : anomaly
        );
        setAnomalies(updatedAnomalies);
    };

    const handleDeleteAnomaly = (id) => {
        const confirmed = window.confirm("Êtes-vous sûr de vouloir supprimer cette anomalie ?");
        if (confirmed) {
            setAnomalies(anomalies.filter((anomaly) => anomaly.id !== id));
        }
    };

    return (
        <div className="max-w-6xl mx-auto p-4">
            <h1 className="text-2xl font-bold mb-6">Gestion des anomalies de production</h1>

            {/* Formulaire pour signaler une anomalie */}
            <div className="bg-white shadow-md rounded p-4 mb-6">
                <h2 className="text-lg font-bold mb-4">Signaler une anomalie</h2>
                {error && <p className="text-red-500 mb-4">{error}</p>}
                {successMessage && <p className="text-green-500 mb-4">{successMessage}</p>}
                <form onSubmit={handleAddAnomaly} className="space-y-4">
                    <div>
                        <label className="block mb-2 font-semibold">Description :</label>
                        <textarea
                            name="description"
                            value={form.description}
                            onChange={handleInputChange}
                            placeholder="Décrivez l'anomalie"
                            className="border border-gray-300 rounded p-2 w-full"
                            required
                        ></textarea>
                    </div>
                    <div>
                        <label className="block mb-2 font-semibold">Étape :</label>
                        <input
                            type="text"
                            name="step"
                            value={form.step}
                            onChange={handleInputChange}
                            placeholder="Étape de production concernée"
                            className="border border-gray-300 rounded p-2 w-full"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 font-semibold">Opérateur :</label>
                        <input
                            type="text"
                            name="operator"
                            value={form.operator}
                            onChange={handleInputChange}
                            placeholder="Nom de l'opérateur"
                            className="border border-gray-300 rounded p-2 w-full"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-700"
                    >
                        Signaler
                    </button>
                </form>
            </div>

            {/* Tableau des anomalies */}
            <div className="bg-white shadow-md rounded p-4">
                <h2 className="text-lg font-bold mb-4">Liste des anomalies</h2>
                {anomalies.length > 0 ? (
                    <table className="w-full border-collapse border border-gray-300">
                        <thead>
                            <tr className="bg-gray-100">
                                <th className="border border-gray-300 p-2">Date</th>
                                <th className="border border-gray-300 p-2">Description</th>
                                <th className="border border-gray-300 p-2">Étape</th>
                                <th className="border border-gray-300 p-2">Opérateur</th>
                                <th className="border border-gray-300 p-2">Statut</th>
                                <th className="border border-gray-300 p-2">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {anomalies.map((anomaly) => (
                                <tr key={anomaly.id}>
                                    <td className="border border-gray-300 p-2">{anomaly.date}</td>
                                    <td className="border border-gray-300 p-2">{anomaly.description}</td>
                                    <td className="border border-gray-300 p-2">{anomaly.step}</td>
                                    <td className="border border-gray-300 p-2">{anomaly.operator}</td>
                                    <td className="border border-gray-300 p-2">{anomaly.status}</td>
                                    <td className="border border-gray-300 p-2">
                                        {anomaly.status === "Signalée" && (
                                            <button
                                                onClick={() => handleResolveAnomaly(anomaly.id)}
                                                className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                                            >
                                                Résoudre
                                            </button>
                                        )}
                                        <button
                                            onClick={() => handleDeleteAnomaly(anomaly.id)}
                                            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-700"
                                        >
                                            Supprimer
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p className="text-center text-gray-500">Aucune anomalie signalée.</p>
                )}
            </div>
        </div>
    );
};

export default ManageProductionAnomalies;
